import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { BlogComponent } from './blog/blog.component';
import { ProfileEditorComponent } from './profile-editor/profile-editor.component';


const routes: Routes = [
  {
    path: 'blog',
    component: BlogComponent
  },
  {
    path: '',
    component: ProfileEditorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
